import { neutralContrastFillActiveDelta, neutralContrastFillFocusDelta, neutralContrastFillHoverDelta, neutralPalette, } from "../fast-design-system";
import { colorRecipeFactory, swatchFamilyToSwatchRecipeFactory, SwatchFamilyType, } from "./common";
import { accessibleAlgorithm } from "./accessible-recipe";
/**
 * @internal
 */
export const neutralContrastFill = colorRecipeFactory(accessibleAlgorithm(neutralPalette, 14, 0, neutralContrastFillHoverDelta, neutralContrastFillActiveDelta, neutralContrastFillFocusDelta));
/**
 * @internal
 */
export const neutralContrastFillRest = swatchFamilyToSwatchRecipeFactory(SwatchFamilyType.rest, neutralContrastFill);
/**
 * @internal
 */
export const neutralContrastFillHover = swatchFamilyToSwatchRecipeFactory(SwatchFamilyType.hover, neutralContrastFill);
/**
 * @internal
 */
export const neutralContrastFillActive = swatchFamilyToSwatchRecipeFactory(SwatchFamilyType.active, neutralContrastFill);
/**
 * @internal
 */
export const neutralContrastFillFocus = swatchFamilyToSwatchRecipeFactory(SwatchFamilyType.focus, neutralContrastFill);
